// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

import { ArchivingFingerprint }         from '@app/modules/archiving/models/archiving-common.model';
import { RequestState }                 from '@core/interfaces/api.interface';
import { IArchivingImportEntityEvents } from '@core/interfaces/entity.interface';

export class ArchivingImportTMO {
	id?: string = undefined;
	businessPremisesId?: string = undefined;
	created?: Date = undefined;
	type?: ArchivingImportTypeEnum = undefined;
	version?: string = undefined;
	status?: ArchivingImportStatusEnum = undefined;
	originImportId?: string = undefined;
	fingerprint?: ArchivingFingerprint = undefined;
	replacementId?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingImport extends ArchivingImportTMO {
	etag?: string = undefined;

	public ui?: IArchivingImportEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {
			exportArchivingTssLogs: {
				isEnabled: true,
				showLoader: false
			}
		}
	};
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
export enum ArchivingImportTypeEnum {
	DFKA = 'DFKA',
	DSFINVK = 'DSFINVK',
}

export enum ArchivingImportStatusEnum {
	BEING_REPLACED = 'beingReplaced',
	ERROR = 'error',
	LOCKED = 'locked',
	OPEN = 'open',
	REPLACED = 'replaced',
}

// UI enums *********************************************************
